import { OrganisationConnection } from "@/types/organisatio";
import { Customer } from "../types";
import { OrganisationWithLicencesResponse } from "@/types/licenceSolutions";

export const transformOrganisationsToCustomers = (
  organisations: OrganisationWithLicencesResponse[],
  connections: OrganisationConnection[],
): Customer[] => {
  const connectionsDictionary = connections.reduce(
    (acc: Record<string, boolean>, cur) => {
      acc[cur.organisation_uuid] = cur.connected;
      return acc;
    },
    {},
  );

  return organisations.map((organisation) => {
    return {
      uuid: organisation.uuid,
      name: organisation.name,
      description: organisation.description ?? "",
      seats_used: organisation.licence?.seats_used || 0,
      seats_purchased: organisation.licence?.seats_purchased || 0,
      total_usage: organisation.licence?.seats_utilized_ratio || 0,
      created_at: organisation.created_at,
      hasConnection: connectionsDictionary[organisation.uuid],
    };
  });
};

export const toKebabCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
};
